import React, { useState } from "react";
import styles from "./CheckAvailability.module.css";
import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import HeadingAndDropDown from "../../components/HeadingAndDropDown/HeadingAndDropDown";
import ToClose from "../../components/ToClose/ToClose";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice";
import { FaRegCalendarCheck } from "react-icons/fa";
import SaveAndCancel from "../../components/SaveAndCancel/SaveAndCancel";

const CheckAvailability = () => {
  const dispatch = useDispatch();

  const [program, setProgram] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [days, setDays] = useState("");
  const [studentsChecked, setStudentsChecked] = useState(false);
  const [staffChecked, setStaffChecked] = useState(false);

  const resetAll = () => {
    setProgram("");
    setFrom("");
    setTo("");
    setDays("");
    setStudentsChecked(false);
    setStaffChecked(false);
  };

  const handleAvailabilityCheck = () => {
    if (!program.trim()) {
      return alert("Please select a program.");
    }
    if (!from) {
      return alert("Please choose a 'From' date.");
    }
    if (!to) {
      return alert("Please choose a 'To' date.");
    }
    if (!days.trim()) {
      return alert("Please select days of the week.");
    }

    console.log({
      program,
      from,
      to,
      days,
      availabilityFor: {
        students: studentsChecked,
        staff: staffChecked,
      },
    });
  };

  return (
    <div className={styles.cardContainer}>
      <div className={styles.cardHeader}>
        <HeadingAndIcon
          icon={<FaRegCalendarCheck />}
          heading="Check Availability"
        />
        <ToClose onClose={() => dispatch(closeModal())} />
      </div>

      <div className={styles.cardBody}>
        <HeadingAndDropDown
          label="Select programs "
          name="program"
          value={program}
          onChange={(e) => setProgram(e.target.value)}
          required
          options={[
            { label: "Annual Day", value: "Annual Day" },
            { label: "Sports Day", value: "Sports Day" },
          ]}
          placeholder="Select programs"
        />

        <div className={styles.row}>
          <div className={styles.inputBlock}>
            <label>From *</label>
            <input
              type="date"
              value={from}
              onChange={(e) => setFrom(e.target.value)}
              className={styles.dateInput}
            />
          </div>
          <div className={styles.inputBlock}>
            <label>To *</label>
            <input
              type="date"
              value={to}
              onChange={(e) => setTo(e.target.value)}
              className={styles.dateInput}
            />
          </div>
        </div>

        <HeadingAndDropDown
          label="Days of the week "
          name="days"
          value={days}
          onChange={(e) => setDays(e.target.value)}
          required
          options={[
            { label: "Monday to Friday", value: "Mon-Fri" },
            { label: "Weekends", value: "Weekends" },
          ]}
          placeholder="Select days"
        />

        <div className={styles.checkboxRow}>
          <label>Check availability for</label>
          <label
            className={`${styles.checkLabel} ${
              studentsChecked ? styles.active : ""
            }`}
          >
            <input
              type="checkbox"
              checked={studentsChecked}
              onChange={(e) => setStudentsChecked(e.target.checked)}
            />
            Students
          </label>
          <label
            className={`${styles.checkLabel} ${
              staffChecked ? styles.active : ""
            }`}
          >
            <input
              type="checkbox"
              checked={staffChecked}
              onChange={(e) => setStaffChecked(e.target.checked)}
            />
            Staff
          </label>
        </div>

        <div className={styles.footer}>
          <SaveAndCancel
            onCancel={resetAll}
            onSave={handleAvailabilityCheck}
            cancelLabel="Cancel"
            saveLabel="check availability"
          />
        </div>
      </div>
    </div>
  );
};

export default CheckAvailability;
